import React from 'react';

interface ButtonRowProps {
  children: React.ReactNode;
  gap?: string;
}

// Lays two (or more) action buttons side by side, stacking them full-width
// on narrow screens instead. Prevents a long label (in either language)
// from wrapping unevenly against a short sibling button — used anywhere a
// Yes/No, Confirm/Cancel, or similar action pair appears. The matching
// `.rezervo-btn-row` media-query rule lives in each page's own <style>
// block, next to its other component-scoped styles.
export default function ButtonRow({ children, gap = '12px' }: ButtonRowProps) {
  return (
    <div className="rezervo-btn-row" style={{ display: 'flex', gap, justifyContent: 'center' }}>
      {children}
    </div>
  );
}
